import React, { Component } from 'react';
import axios from 'axios'
import moment from 'moment-jalaali'
import { confirmDialog } from 'primereact/confirmdialog'; // To use confirmDialog method
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { BrowserRouter, Route,  Navigate } from 'react-router-dom'
import { Multiselect } from 'multiselect-react-dropdown';
import Server from '../Server.js'
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { SelectButton } from 'primereact/selectbutton';
import { connect } from 'react-redux';
import { Loader } from 'rsuite';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
const FilterItems = [
  { label: 'پذیرندگان', value: 'shops' },
  { label: 'کاربران', value: 'users' }



];
class SendSms extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.FieldRef = React.createRef();
    this.toast = React.createRef();

   
    
    
    this.state = {
      layout: 'list',
      name: "",
      type: "1",
      FId: "",
      DbTableName: "",
      DBTableField: "",
      confirm:false,
      active:false,
      Filter:"shops",
      selectedCustomers:[],
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(1)

    }
  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1
    })
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        loading: 0
      })
      that.GetShops();

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
  }
  GetUsers() {
    let that = this;
    this.setState({
      loading: 1
    })

    let param = {
      token: localStorage.getItem("api_token"),
      GetAll: 1,
      systemId: null
    };
    let SCallBack = function (response) {
      
      const data = response.data.result.map((item,index)=>{
        let credit = item.credit;
        if(item.wallet){
            item.wallet.map((wallet)=>{
                credit+=wallet.credit
            })
        }
        
        return({
            readif:index+1,
            username:item.username,
            name:item.name,
            credit:credit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        })
    })
      that.setState({
        GridData: data,
        loading: 0

      })
      that.getLevel();
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("AdminApi/getuser", param, SCallBack, ECallBack)
  }
  GetShops() {
    let that = this;
    let param = {
      ShopId: null
    };
    that.setState({
      loading: 1
    })
    let SCallBack = function (response) {
        
        const data = response.data.result.map((item,index)=>{
            let credit = item.credit;
            if(item.wallet){
                item.wallet.map((wallet)=>{
                    credit+=wallet.credit
                })
            }
            return({
                readif:index+1,
                username:item.mobile,
                name:item.name,
                credit:credit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            })
        })

      that.setState({
        GridData: data,
        loading: 0
      })

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("AdminApi/ShopInformation", param, SCallBack, ECallBack)
  }
  send(){
    let that = this;
    
    let selected =[]
    for(let item of this.state.selectedCustomers){
        if(item.username.indexOf("-") != -1){
           for(let i=0;i<item.username.split("-").length;i++){
            selected.push(item.username.split("-")[i]);
           } 
        }else{
            selected.push(item.username);
        }
    }
    let param = {
        mobiles: selected,
        text:this.state.text
    };
    that.setState({
      loading: 1
    })
    let SCallBack = function (response) {
        that.toast.current.show({severity: 'success', summary: 'ارسال پیامک', detail: <div> متن پیامک در صف ارسال قرار گرفت </div>, life: 8000});

      that.setState({
        loading: 0
      })

    };
    let ECallBack = function (error) {
        that.toast.current.show({severity: 'err', summary: 'ارسال پیامک', detail: <div> خطا در برقراری ارتباط </div>, life: 8000});

      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/SendSmsFromPanel", param, SCallBack, ECallBack)

  }
  convertNum(str){
    var persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
       latinNumbers  = [/0/g, /1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g];
     
        if(typeof str === 'string')
        {
          for(var i=0; i<10; i++)
          {
            str = str.replace(persianNumbers[i], i).replace(latinNumbers[i], i);
          }
        }
        return str;
  }
 
  render() {
    return (
      <div style={{ direction: 'rtl' }}>
        {this.state.loading == 1 &&
          <div style={{ position: 'fixed', zIndex: 2000, top: 10, left: 15, backgroundColor: '#e89f31', padding: '2px 20px' }}>
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        }

        <Toast ref={this.toast} position="bottom-left" style={{ fontFamily: 'YekanBakhFaBold', textAlign: 'right' }} />
        <button className="btn btn-info irsans" disabled={this.state.selectedCustomers.length == 0} onClick={()=>{this.setState({
            visibleDialog:true
        })}} style={{ width: "300px", marginTop: "20px", marginBottom: "20px" }}>آماده سازی متن / ارسال پیامک </button>

        <div style={{ textAlign: 'right', marginBottom: 10,marginTop:20 }}>
              <SelectButton value={this.state.Filter} options={FilterItems} style={{ fontFamily: 'Yekan' }} className="yekan" onChange={(e) => { 
                if(e.value != null){
                  this.setState({ Filter: e.value }); 
                  if(e.value == "shops"){
                    this.GetShops(e.value)
                  }else{
                    this.GetUsers(e.value)
                  }
                }
                }}></SelectButton>

        </div>

        <div className="row justify-content-center">

          <div className="col-12" style={{ background: '#fff' }}>
           
            <div className="section-title " style={{ textAlign: 'right' }}><span className="title IRANYekan" style={{ fontSize: 17, color: 'gray' }} >لیست رکورد ها</span></div>

            <DataTable responsive value={this.state.GridData} paginator  rows={10} selection={this.state.selectedCustomers} onSelectionChange={e => this.setState({ selectedCustomers: e.value })}  >
              <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>
              <Column field="readif" header="ردیف" className="irsans" style={{ textAlign: "right",width:60 }} />
              <Column field="name" filter={true} header="نام" className="irsans" style={{ textAlign: "right" }} />
              <Column field="username" filter={true} header="تلفن همراه" className="irsans" style={{ textAlign: "right" }} />
              <Column field="credit" filter={true} header="موجودی" className="irsans" style={{ textAlign: "right" }} />

              
            </DataTable>
          </div>

        </div>

        <Dialog header="آماده سازی متن / ارسال پیامک" visible={this.state.visibleDialog} style={{ width: '80vw' }} minY={70} onHide={()=>{
          this.setState({
            visibleDialog:false
          })
        }} maximizable={true}>
          <div style={{ overflowY: 'auto', overflowX: 'hidden', minHeight: 400 }}>
             <div className="row" >
              <div className="col-lg-12">
                <div className="group">
                  <textarea className="form-control iranyekanweblight" autoComplete="off"  type="text" value={this.state.text} name="text" onChange={(event)=>{
                      this.setState({
                        text:event.target.value
                      })
                  }} rows="3"  style={{textAlign:'right'}} required="true"/>
                  <label>متن پیامک</label>
                </div>
                
                <div>
                <Button style={{marginLeft:5,marginTop:10}} color="primary" disabled={this.state.loading}  className="iranyekanweblight" onClick={()=>{
                    this.send()
                }}>ارسال</Button>

                </div>
              </div> 
              </div>
          </div>
          
        </Dialog>


      </div>





    )
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  }
}
export default connect(mapStateToProps)(SendSms)
